import { Card, XStack } from '@ninjacart/nc-nk-ui';
import {CropsSelectionCard} from '@ninjacart/nc-nk-adaptive-cards';
export const ProfileCropsCard = () => {
  const showCropsCard = () => {
    return <CropsSelectionCard sourcePage="Profile" />;
  };

  return (
    <XStack>
      <Card width={'100%'} marginVertical={2} backgroundColor="$cardbackground">
        {showCropsCard()}
      </Card>
    </XStack>
  );
};
